import React from 'react';
import { connect } from 'react-redux';
import { Table, Badge } from 'antd';

import { $t } from 'src/tools';
import ModalWrapper from 'src/FBFormComponents/ModalWrapper';
import styles from './index.less';

class ImportHistory extends React.PureComponent {
  get isUpload() {
    const { temp } = this.props;
    return Number(temp) === 1;
  }
  get columns() {
    const { locales } = this.props;

    return [
      {
        title: $t('idx', locales),
        dataIndex: 'idx',
        render: (txt, record, idx) => idx + 1,
      },
      {
        width: 240,
        title: $t('filename', locales),
        dataIndex: 'name',
      },
      {
        title: $t(`${this.isUpload ? 'im' : 'ex'}port_content`, locales),
        dataIndex: 'content',
      },
      {
        title: $t('operator', locales),
        dataIndex: 'operation_name',
      },
      {
        title: $t(`${this.isUpload ? 'im' : 'ex'}port_request_time`, locales),
        dataIndex: 'time',
      },
      {
        title: $t('status', locales),
        dataIndex: 'status',
        render: (txt) => (
          <div>
            <Badge
              status={
                {
                  1: 'processing',
                  2: 'success',
                  3: 'error',
                }[txt]
              }
            />
            <span>
              {$t(
                `${this.isUpload ? 'im' : 'ex'}${
                  {
                    1: 'port_ing',
                    2: 'port_already',
                    3: 'port_not',
                  }[txt]
                }`,
                locales
              )}
            </span>
          </div>
        ),
      },
      this.isUpload && {
        title: '',
        dataIndex: 'result',
        render: (txt, record) =>
          String(record.status) === '3' && (
            <div
              className={styles['import-history-active']}
              onClick={this.handleShowResult(record)}
            >
              {$t('show_result', locales)}
            </div>
          ),
      },
      {
        title: $t('operation', locales),
        align: 'center',
        dataIndex: 'operate',
        render: (txt, record) =>
          (String(record.status) === '2' || this.isUpload) && (
            <div className={styles['import-history-active']} onClick={this.handleExport(record)}>
              {$t('download', locales)}
            </div>
          ),
      },
    ].filter(Boolean);
  }
  componentDidMount() {
    this.handleChange({ page: 1, page_num: 10 });
  }
  render() {
    const { source, loading, query, userInfo, locales } = this.props;

    return (
      <>
        {!Number(userInfo.main_account) && (
          <div style={{ paddingBottom: 10 }}>
            {$t(`${this.isUpload ? 'im' : 'ex'}port_history_tip`, locales)}
          </div>
        )}
        <Table
          rowKey="id"
          loading={loading}
          columns={this.columns}
          dataSource={source.list}
          onChange={this.handlePageChange}
          className={styles['import-history-table']}
          pagination={
            source.total <= (query.page_num || 10)
              ? false
              : {
                  size: 'small',
                  total: source.total,
                  current: query.page,
                  showQuickJumper: true,
                  pageSize: query.page_num || 10,
                }
          }
          scroll={{ y: window.innerHeight * 0.8 - 160 }}
        />
      </>
    );
  }
  handleExport = (record) => {
    return () => {
      const { dispatch } = this.props;
      dispatch({ type: 'down/fetchImportTask', payload: { task_id: record.id } });
    };
  };
  handlePageChange = (page) => {    
    this.handleChange({ page: page.current || 1, page_num: page.pageSize || 10 });
  };
  // modal 请求内容更新
  handleChange = (query) => {
    const { dispatch, temp } = this.props;
    dispatch({
      type: 'down/fetchImportList',
      payload: { ...query, type: !!temp ? 'import_excel' : 'excel' },
    });
  };
  handleShowResult = (record) => {
    return () => {
      this.props.dispatch({
        type: 'down/setState',
        payload: { record, recordVisible: true },
      });
    };
  };
}

export default ModalWrapper(
  connect(({ downState, appState }) => ({ ...downState, userInfo: appState.userInfo }))(
    ImportHistory
  )
);
